import React from "react";
import JSONPretty from "react-json-pretty";

const API = () => {
  return (
    <article className="container px-4 prose prose-lg">
      <div className="text-center text-4xl">
        <a target="_blank" rel="noopener noreferrer" href="https://stoic-server.vercel.app/">
          Access the Stoic Wisdom API here
        </a>
      </div>
      <h2>Random Quote</h2>
      <table>
        <thead>
          <tr>
            <th>HTTP Method</th>
            <th>GET</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>URL</td>
            <td className="break-all">
              <a target="_blank" rel="noopener noreferrer" href="https://stoic-server.vercel.app/random">
                https://stoic-server.vercel.app/random
              </a>
            </td>
          </tr>
          <tr>
            <td>Description</td>
            <td>Returns a random quote object.</td>
          </tr>
        </tbody>
      </table>
      <h2>Quote by ID</h2>
      <table>
        <thead>
          <tr>
            <th>HTTP Method</th>
            <th>GET</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>URL</td>
            <td className="break-all">
              <a target="_blank" rel="noopener noreferrer" href="https://stoic-server.vercel.app/quotes/1">
                {"https://stoic-server.vercel.app/quotes/1"}
              </a>
            </td>
          </tr>
          <tr>
            <td>Description</td>
            <td>
              If a quote is found with the corresponding {"{id}"}, that specifc
              quote is returned.
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Searching Quotes, Authors and Sources</h2>
      <table>
        <thead>
          <tr>
            <th>HTTP Method</th>
            <th>GET</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>URL</td>
            <td className="break-all">
              <a target="_blank" rel="noopener noreferrer" href="https://stoic-server.vercel.app/search/searchterm">
                {"https://stoic-server.vercel.app/search/searchterm"}
              </a>
            </td>
          </tr>
          <tr>
            <td>Description</td>
            <td>
              Returns results that match the {"{searchterm}"} parameter, with
              results weighted first by author, then body then quotesource.
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Messages</h2>
      <p>
        In the event of an error occuring, a message object is returned,
        containing relevant information about the request.
      </p>
      <h3>Quote object</h3>
      <p>A quote object is a simple text quote.</p>
      <h4>Response fields</h4>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>integer</td>
            <td>The unique ID of this quote.</td>
          </tr>
          <tr>
            <td>body</td>
            <td>string</td>
            <td>The actual quote.</td>
          </tr>
          <tr>
            <td>author</td>
            <td>string</td>
            <td>The author of the quote.</td>
          </tr>
          <tr>
            <td>quotesource</td>
            <td>string</td>
            <td>Reference to the origin of the quote.</td>
          </tr>
          <tr>
            <td>keywords</td>
            <td>array</td>
            <td>
              Keywords are calculated using natural language processing and
              tf-idf calculations
            </td>
          </tr>
          <tr>
            <td className="break-all">documents_with_weights</td>
            <td>string</td>
            <td className="break-words">
              tsvector calculations forming part of postgreql text search
              functionality
            </td>
          </tr>
        </tbody>
      </table>
      <h4>Example</h4>
      <JSONPretty
        data={{
          id: 337,
          body: "Today I have got out of all trouble, or rather I have cast out all trouble, for it was not outside, but within and in my opinions.",
          author: "Marcus Aurelius",
          quotesource: "Meditations, IX.13",
          keywords: [
            "opinions",
            "outside",
            "within",
            "trouble",
            "rather",
            "today",
            "cast",
          ],
          document_with_weights:
            "'aurelius':2A 'cast':15B 'got':6B 'ix.13':31C 'marcus':1A 'medit':30C 'opinion':29B 'outsid':23B 'rather':12B 'today':3B 'troubl':10B,18B 'within':25B",
        }}
      ></JSONPretty>
      <h3>Message object</h3>
      <p>
        A message object contains information about the status of the requested
        API URL.
      </p>
      <h4>Response fields</h4>
      <JSONPretty
        data={{
          status: "error",
          statusCode: 404,
          message: "No result found with search 'iphone'",
        }}
      ></JSONPretty>
    </article>
  );
};

export default API;
